import React, { forwardRef } from 'react';

interface BellFullProps {
  classes?: string;
  style?: React.CSSProperties;
}

export const BellFull = forwardRef<HTMLElement, BellFullProps>(({ classes, style = {} }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-bell ${classes || ''}`} style={style}></i>
  );
});

BellFull.displayName = 'BellFull';
